import { render, staticRenderFns } from "./NominationScoreShow.vue?vue&type=template&id=15145604&scoped=true"
import script from "./NominationScoreShow.vue?vue&type=script&lang=js"
export * from "./NominationScoreShow.vue?vue&type=script&lang=js"
import style0 from "./NominationScoreShow.vue?vue&type=style&index=0&id=15145604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15145604",
  null
  
)

export default component.exports